import Skeleton from 'react-loading-skeleton'

export default function SkeletonProduct() {
    return (
        <div className="product-grid">
            {Array.from({ length: 8 }).map((_, i) => (
                <div key={i} className="product-card-dtl">
                    <Skeleton height={200} />
                    <Skeleton height={20} />
                </div>
            ))}
        </div>
    )
}
